import { classed } from "@frend-digital/ui";
import styles from "./IconButton.module.css";

export const IconButton = classed("button", styles.root, {
	variants: {
		variant: {
			outlined: styles.outlined,
		},
	},
});
